module.exports = __webpack_public_path__ + "img/service01.14cc2298.svg";